import { createRoot } from "react-dom/client";
import App from "./App";
import "./assets/css/styles.scss";

const node = document.getElementById("root");
const root = createRoot(node);

root.render(<App />);
